import axios from "axios";
import { API_URL } from '../api.js'

const api = `${API_URL}/restaurant`

export default {
    async getCustomers(restaurantId) {
        const resp = await axios.get(`${api}/${restaurantId}/customers`);
        return resp.data;
    },
    async editLoyaltyProgram(restaurantId, loyaltyProgram) {
        const resp = await axios.post(`${api}/editloyaltyprogram`, {
            restaurantId,
            loyaltyProgram
        });
        return resp.data;
    }
};
